<div class="account-hero">
  <div class="account-hero__glow account-hero__glow--left"></div>
  <div class="account-hero__glow account-hero__glow--right"></div>
  <div class="account-hero__grid"></div>

  <div class="account-hero__content">
    <router-outlet></router-outlet>
  </div>
</div>
